var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
import { CrudService, Resource } from '../client';
import { resources } from '../resources';
let ProductService = class ProductService extends CrudService {
    /**
     * Load Product by given sku.
     */
    findBySku(sku) {
        return super.findOne(sku, { useNumberAsId: true });
    }
};
ProductService = __decorate([
    injectable(),
    Resource(resources.products)
    /**
     * The ProductService handles the operations for the product api resource.
     *
     * @example
     * How to use the ProductService in a component:
     * ...
     * export class MyComponent {
     *     private readonly productService = container.resolve(ProductService)
     *
     *     componentWillLoad() {
     *         const { data } = await this.productService.findOne(123)
     *     }
     * }
     */
], ProductService);
export { ProductService };
//# sourceMappingURL=product.service.js.map